import store from "../store";

//TODO: add permission
export const permissions = {
    viewSuperAdmin : "super-admin",
    viewDashBoard: "view dashboard",
    inventoryView: "inventory.view",
    inventoryOverviewView: "inventory.overview.view",

    inventoryProductsView: "inventory.products.view",
    inventoryProductsImport: "inventory.products.import",
    inventoryProductsExport: "inventory.products.export",
    inventoryProductsPriceView: "inventory.products.price.view",
    inventoryProductsDetailView: "inventory.products.detail.view",
    inventoryProductsUpdate: "inventory.products.update",

    inventoryMaterialsView: "inventory.materials.view",
    inventoryMaterialsImport: "inventory.materials.import",
    inventoryMaterialsExport: "inventory.materials.export",
    inventoryMaterialsUpdate: "inventory.materials.update",

    inventorySheetsView: "inventory.sheets.view",
    inventorySheetsImport: "inventory.sheets.import",
    inventorySheetsExport: "inventory.sheets.export",
    inventorySheetsUpdate: "inventory.sheets.update",
    inventorySheetsImportView: "inventory.sheets.import.view",
    inventorySheetsExportView: "inventory.sheets.export.view",

    inventoryReportsView: "inventory.reports.view",
    inventoryReportsProductsView: "inventory.reports.products.view",
    inventoryReportsProductsDetailView: "inventory.reports.products.detail.view",
    inventoryReportsProductsOrder: "inventory.reports.products.order",
    inventoryReportsProductsUpdate: "inventory.reports.products.update",
    inventoryReportsSheetsView: "inventory.reports.sheets.view",
    inventoryReportsSheetsOrder: "inventory.reports.sheets.order",
    inventoryReportsSheetsUpdate: "inventory.reports.sheets.update",

    saleView: "sale.view",
    saleOrdersCreate: "sale.orders.create",
    saleOrdersUpdate: "sale.orders.update",
    saleOrdersAllView: "sale.orders.all.view",

    customerView: 'customer.view',
    customerCustomersView: 'customer.customers.view',
    customerCustomersSpecialView: 'customer.customers.special.view',
    customerCustomersAllCreditLimitView: 'customer.customers.all.credit-limit.view',
    customerCustomersCreate: 'customer.customers.create',
    customerCustomersUpdate: 'customer.customers.update',
    customerVendorsView: 'customer.vendors.view',
    customerVendorsCreate: 'customer.vendors.create',
    hideWarehouseLead : 'hide.warehouse.lead',

    viewPurchases: "purchases.view",
    viewTransports: "transports.view",
    viewAccounting: "accounting.view",
    viewHR:         "hr.view",

    //driver
    viewDriver : "driver.view",
    viewDriverAll : "driver.view.all",
};

//TODO: add function check permission
export function canViewDashboard() {
    return canUser(permissions.viewDashBoard);
}
export function canViewSuperAdmin() {
    return canUser(permissions.viewSuperAdmin);
}
// Inventory.
export function canInventoryView() {
    return canUser(permissions.inventoryView);
}

export function canInventoryOverviewView() {
    return canUser(permissions.inventoryOverviewView);
}

export function canInventoryProductsView() {
    return canUser(permissions.inventoryProductsView);
}

export function canInventoryProductsImport() {
    return canUser(permissions.inventoryProductsImport);
}

export function canInventoryProductsExport() {
    return canUser(permissions.inventoryProductsExport);
}

export function canInventoryProductsPriceView() {
    return canUser(permissions.inventoryProductsPriceView);
}

export function canInventoryProductsDetailView () {
    return canUser(permissions.inventoryProductsDetailView)
}

export function canInventoryProductsUpdate() {
    return canUser(permissions.inventoryProductsUpdate);
}

export function canInventoryMaterialsView() {
    return canUser(permissions.inventoryMaterialsView);
}

export function canInventoryMaterialsImport() {
    return canUser(permissions.inventoryMaterialsImport);
}

export function canInventoryMaterialsExport() {
    return canUser(permissions.inventoryMaterialsExport);
}

export function canInventoryMaterialsUpdate() {
    return canUser(permissions.inventoryMaterialsUpdate);
}

export function canInventorySheetsView() {
    return canUser(permissions.inventorySheetsView);
}

export function canInventorySheetsImport() {
    return canUser(permissions.inventorySheetsImport);
}

export function canInventorySheetsExport() {
    return canUser(permissions.inventorySheetsExport);
}

export function canInventorySheetsImportView() {
    return canUser(permissions.inventorySheetsImportView);
}

export function canInventorySheetsExportView() {
    return canUser(permissions.inventorySheetsExportView);
}

export function canInventorySheetsUpdate() {
    return canUser(permissions.inventorySheetsUpdate);
}

export function canInventoryReportsView() {
    return canUser(permissions.inventoryReportsView);
}

export function canInventoryReportsProductsView() {
    return canUser(permissions.inventoryReportsProductsView);
}

export function canInventoryReportsProductsDetailView() {
    return canUser(permissions.inventoryReportsProductsDetailView);
}

export function canInventoryReportsProductsOrder() {
    return canUser(permissions.inventoryReportsProductsOrder);
}

export function canInventoryReportsProductsUpdate() {
    return canUser(permissions.inventoryReportsProductsUpdate);
}

export function canInventoryReportsSheetsView() {
    return canUser(permissions.inventoryReportsSheetsView);
}

export function canInventoryReportsSheetsOrder() {
    return canUser(permissions.inventoryReportsSheetsOrder);
}

export function canInventoryReportsSheetsUpdate() {
    return canUser(permissions.inventoryReportsSheetsUpdate);
}

// [END] Inventory

// Sale
export function canSaleView() {
    return canUser(permissions.saleView)
}

export function canSaleOrdersAllView() {
    return canUser(permissions.saleOrdersAllView)
}

export function canSaleOrdersCreate() {
    return canUser(permissions.saleOrdersCreate)
}

export function canSaleOrdersUpdate() {
    return canUser(permissions.saleOrdersUpdate)
}

// [END] Sale

// Customer
export function canCustomerView() {
    return canUser(permissions.customerView)
}

export function canCustomerCustomersView() {
    return canUser(permissions.customerCustomersView)
}

export function canCustomerCustomersSpecialView() {
    return canUser(permissions.customerCustomersSpecialView)
}

export function canCustomerCustomersAllCreditLimitView() {
    return canUser(permissions.customerCustomersAllCreditLimitView)
}

export function canCustomerCustomersCreate() {
    return canUser(permissions.customerCustomersCreate)
}

export function canCustomerCustomersUpdate() {
    return canUser(permissions.customerCustomersUpdate)
}

export function canVendorsView() {
    return canUser(permissions.customerVendorsView)
}
export function canCustomerVendorsCreate() {
    return canUser(permissions.customerVendorsCreate)
}
export function hideWarehouseLead() {
    return canUser(permissions.hideWarehouseLead)
}
// [END] Customer

export function canViewPurchases() {
    return canUser(permissions.viewPurchases);
}

export function canViewTransports() {
    return canUser(permissions.viewTransports);
}

export function canViewAccounting() {
    return canUser(permissions.viewAccounting);
}

export function canViewHR() {
    return canUser(permissions.viewHR);
}

//Driver
export function canViewDriver() {
    return canUser(permissions.viewDriver);
}
export function canViewDriverAll() {
    return canUser(permissions.viewDriverAll);
}
export function canUser(requestedPermission) {
    // Can user do action.
    const matchedPermission = store.state.Auth.user.permissions.find(
        permission => permission.name === requestedPermission
    );
    // Return boolean
    return !!matchedPermission;
}

export default {
    permissions,
    canViewDashboard,
    canInventoryView,
    canInventoryOverviewView,
    canInventoryProductsView,
    canInventoryProductsImport,
    canInventoryProductsExport,
    canInventoryProductsPriceView,
    canInventoryProductsDetailView,
    canInventoryProductsUpdate,
    canInventoryMaterialsView,
    canInventoryMaterialsImport,
    canInventoryMaterialsExport,
    canInventoryMaterialsUpdate,
    canInventorySheetsView,
    canInventorySheetsImport,
    canInventorySheetsExport,
    canInventorySheetsUpdate,
    canInventorySheetsImportView,
    canInventorySheetsExportView,
    canInventoryReportsView,
    canInventoryReportsProductsView,
    canInventoryReportsProductsDetailView,
    canInventoryReportsProductsOrder,
    canInventoryReportsProductsUpdate,
    canInventoryReportsSheetsView,
    canInventoryReportsSheetsOrder,
    canInventoryReportsSheetsUpdate,

    canSaleView,
    canSaleOrdersAllView,
    canSaleOrdersCreate,
    canSaleOrdersUpdate,

    canCustomerView,
    canCustomerCustomersView,
    canCustomerCustomersAllCreditLimitView,
    canCustomerCustomersCreate,
    canCustomerCustomersUpdate,
    canVendorsView,
    hideWarehouseLead,

    canViewPurchases,
    canViewTransports,
    canViewAccounting,
    canViewHR,
    canViewDriver,
    canViewDriverAll,
    canViewSuperAdmin
};
